import { createFileRoute } from "@tanstack/react-router";

import { GroupLanding } from "../components/landing/group-landing";
import { GROUP_PAGES, groupPageJsonLd } from "../lib/group-pages";
import { seo } from "../lib/head";

const page = GROUP_PAGES.lists;

export const Route = createFileRoute("/listes-en-groupe")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: page.seoTitle,
      description: page.seoDescription,
      image: page.ogImage,
      jsonLd: groupPageJsonLd(page),
    }),
  component: () => <GroupLanding mode="lists" />,
});
